export default __webpack_public_path__ + "static/media/grabit-media-icon.e3513b55.png";